export default "__VITE_ASSET__DhSPuAR___"